import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/display',
    name: 'display',
    component: () => import('../views/Display.vue'),
    meta: { layout: 'blank', title: '院感态势屏' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: { layout: 'blank', title: '登录' },
  },
  {
    path: '/',
    component: () => import('../layouts/DefaultLayout.vue'),
    redirect: () => (window.location.hostname === 'display.yuangan.densematrix.ai' ? '/display' : '/dashboard'),
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('../views/Overview.vue'),
        meta: { title: '感控风险总览' },
      },
      {
        path: 'alerts',
        name: 'alerts',
        component: () => import('../views/Alerts.vue'),
        meta: { title: '风险预警' },
      },
      {
        path: 'monitoring/surface',
        name: 'surface-monitoring',
        component: () => import('../views/MonitoringEvents.vue'),
        meta: { title: '物表检测', eventCategory: 'surface' },
      },
      {
        path: 'monitoring/workbench',
        name: 'monitoring-workbench',
        component: () => import('../views/Dashboard.vue'),
        meta: { title: '综合复核台' },
      },
      {
        path: 'hand-hygiene',
        name: 'hand-hygiene',
        component: () => import('../views/MonitoringEvents.vue'),
        meta: { title: '手卫生管理', eventCategory: 'hand' },
      },
      {
        path: 'annotation-queue',
        name: 'annotation-queue',
        component: () => import('../views/AnnotationQueue.vue'),
        meta: { title: '标注队列', adminOnly: true },
      },
      {
        path: 'events/:eventId',
        name: 'event-detail',
        component: () => import('../views/EventDetail.vue'),
        meta: { title: '事件详情' },
      },
      {
        path: 'devices',
        name: 'devices',
        component: () => import('../views/Devices.vue'),
        meta: { title: '设备管理' },
      },
      {
        path: 'devices/:deviceId',
        name: 'device-detail',
        component: () => import('../views/DeviceDetail.vue'),
        meta: { title: '设备详情' },
      },
      {
        path: 'environments',
        name: 'environments',
        component: () => import('../views/Environments.vue'),
        meta: { title: '环境卫生学监测' },
      },
      {
        path: 'protocol',
        name: 'protocol',
        component: () => import('../views/ProtocolSchemas.vue'),
        meta: { title: '协议配置' },
      },
      {
        path: 'audit',
        name: 'audit',
        component: () => import('../views/Audit.vue'),
        meta: { title: '审计留痕' },
      },
      ...[
        ['disinfection-isolation', 'disinfection', '消毒隔离管理'],
        ['mdro', 'mdro', '多重耐药菌管理'],
        ['antibiotics', 'antibiotics', '抗菌药物管理'],
        ['occupational-exposure', 'exposure', '职业暴露管理'],
        ['rectification', 'rectification', '闭环整改管理'],
        ['config/locations', 'locations', '设备点位'],
        ['config/rules', 'rules', '监测规则'],
        ['system/users', 'users', '用户与角色'],
        ['system/notifications', 'notifications', '通知配置'],
        ['system/integrations', 'integrations', '接口状态'],
      ].map(([path, moduleKey, title]) => ({
        path,
        name: `preview-${moduleKey}`,
        component: () => import('../views/PreviewModule.vue'),
        meta: { title, moduleKey },
      })),
    ],
  },
  { path: '/:pathMatch(.*)*', redirect: '/dashboard' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  const requiresAdmin = to.meta?.adminOnly || (to.name === 'event-detail' && to.query.annotation === '1')
  if (requiresAdmin && localStorage.getItem('yuangan_user_mode') !== 'admin') {
    return '/dashboard'
  }
  if (to.meta?.title) {
    document.title = `${to.meta.title} · 院感`
  }
})

export default router
